export type CampaignInspectionModel = {
  cache_key: number,
  campaign_id: number,
  dates: {
    inspection: {
      date: string,
    },
  },
  date_parts: {
    inspection: {
      date: string,
      date_ordinalized: string,
      day: string,
      day_abbreviation: string,
      end:string,
      end_12hr: string,
      end_meridian: string,
      month: string,
      month_abbreviation: string,
      start: string,
      start_12hr: string,
      start_meridian: string,
    },
  },
  id: number,
  times: {
    inspection: {
      end: string,
      start: string,
    },
  },
  user_id?: number,
}

export type CampaignInspectionRequestOptions = {}

const state = {
  campaign_id: undefined,
  end_time: '',
  id: null,
  inspection_date: '',
  start_time: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'campaign_id' },
  { key: 'end_time' },
  { key: 'inspection_date' },
  { key: 'start_time' },
]

export default state
